// Tryb — the list of everything this facilitator runs.

import { Badge, Button, Icon } from "../../ds/index.js";
import { Card } from "../../components/Card.jsx";
import { useStudio } from "../../lib/studioContext.js";
import { iconForCategory } from "../../lib/useFieldViews.js";
import { trybRow } from "../../lib/studioView.js";

export default function MyTrybs({ onNavigate, onStartListing, onEditListing }) {
  const { state, trybs } = useStudio();

  return (
    <Card padding="8px 24px">
      {!trybs.length && (
        <div style={{ padding: "48px 28px", textAlign: "center", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
          <div style={{ fontFamily: "var(--font-display)", fontSize: "var(--text-xl)", fontWeight: 800, letterSpacing: "var(--tracking-tight)" }}>
            No trybs yet
          </div>
          <div style={{ color: "var(--text-muted)", fontSize: "var(--text-sm)", maxWidth: 380, lineHeight: 1.5 }}>
            Yes, there are a lot of questions. Most already have a sensible answer filled in. You’re mostly just checking.
          </div>
          <Button variant="accent" onClick={onStartListing}>
            Start your first tryb
          </Button>
        </div>
      )}

      {trybs.map((t) => {
        const g = trybRow(t, state.reupPublished, iconForCategory);
        return (
          <div key={g.id} style={{ borderTop: "1px solid var(--border-subtle)" }}>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "2fr 1.4fr 1.2fr 1fr auto",
              alignItems: "center",
              gap: 16,
              padding: "16px 0",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: 14, minWidth: 0 }}>
              <div
                style={{
                  width: 44, height: 44, borderRadius: "var(--radius-sm)", background: g.color, color: "var(--sand-50)",
                  display: "flex", alignItems: "center", justifyContent: "center", flex: "none",
                }}
              >
                <Icon name={g.icon} size={22} />
              </div>
              <div style={{ minWidth: 0 }}>
                <div style={{ fontWeight: 700, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{g.title}</div>
                <div style={{ fontSize: "var(--text-xs)", color: "var(--text-muted)" }}>{g.cat}</div>
              </div>
            </div>

            <div style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-xs)", color: "var(--text-secondary)", lineHeight: 1.6 }}>{g.meta}</div>
            <div style={{ fontFamily: "var(--font-mono)", fontSize: "var(--text-xs)", color: "var(--text-secondary)", lineHeight: 1.6 }}>{g.seats}</div>

            <Badge tone={g.tone} dot>
              {g.status}
            </Badge>

            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              {g.canReup && !state.reupPublished && (
                <Button size="sm" variant="primary" onClick={() => onNavigate("reup")}>
                  Confirm season 2
                </Button>
              )}
              <Button size="sm" variant={g.sentBack ? "primary" : "ghost"} onClick={onEditListing}>
                {g.sentBack ? "Edit and resubmit" : "Edit"}
              </Button>
            </div>
          </div>
          {g.note && (
            <div
              style={{
                margin: "0 0 16px",
                padding: "12px 16px",
                borderRadius: "var(--radius-md)",
                background: g.sentBack ? "var(--danger-soft)" : "var(--warning-soft)",
                fontSize: "var(--text-sm)",
                lineHeight: 1.5,
              }}
            >
              {g.sentBack && <strong style={{ display: "block", marginBottom: 2 }}>A note from our team</strong>}
              {g.note}
            </div>
          )}
          </div>
        );
      })}
    </Card>
  );
}
